"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { classNames } from "../../utilities/props.js";
import { GlobalColorMode, PrivateTheme } from "../Theme/index.js";
import { ToastProvider } from "../Toast/index.js";
import { useGlobalColorMode } from "../Theme/useTheme.js";
import { SingletonEnvironmentContext, useSingletonEnvironment, } from "../../hooks/_private/useSingletonEnvironment.js";
import { SingletonKeyboardModeProvider } from "../../hooks/_private/useSingletonKeyboardMode.js";
import { SingletonHotkeysProvider } from "../../hooks/_private/useSingletonHotkeys.js";
import "./Reshaped.css";
import s from "./Reshaped.module.css";
const ReshapedInner = (props) => {
    const { children, defaultRTL, defaultViewport = "s", toastOptions } = props;
    const rtlState = useSingletonEnvironment(defaultRTL);
    return (_jsx(SingletonKeyboardModeProvider, { children: _jsx(SingletonEnvironmentContext.Provider, { value: { rtl: rtlState, defaultViewport }, children: _jsx(SingletonHotkeysProvider, { children: _jsx(ToastProvider, { options: toastOptions, children: children }) }) }) }));
};
const Reshaped = (props) => {
    const { theme, defaultTheme = "reshaped", colorMode, defaultColorMode, scoped, className, } = props;
    const rootClassNames = classNames(s.root, className);
    const scopeRef = React.useRef(null);
    const parentGlobalColorMode = useGlobalColorMode();
    return (_jsx(GlobalColorMode, { defaultMode: defaultColorMode || parentGlobalColorMode.mode || "light", mode: colorMode, scopeRef: !!parentGlobalColorMode && scoped ? scopeRef : undefined, children: _jsx(PrivateTheme, { name: theme, defaultName: defaultTheme, className: rootClassNames, scoped: scoped, scopeRef: !!parentGlobalColorMode && scoped ? scopeRef : undefined, children: _jsx(ReshapedInner, { ...props, children: props.children }) }) }));
};
Reshaped.displayName = "Reshaped";
export default Reshaped;
